import store from "@/store";

export default function hasActiveNotCompletedWeightLossProgram({
  next,
  router,
}) {
  const hasActiveWeightLossProgram =
    store.getters["user/hasActiveWeightLossProgram"];
  const hasDoneAnyWeekInActiveWeightLossProgram =
    store.getters["user/hasDoneAnyWeekInActiveWeightLossProgram"];

  if (hasActiveWeightLossProgram && !hasDoneAnyWeekInActiveWeightLossProgram) {
    return next();
  }

  return router.push({ name: "WeightLoss.Dashboard" });
}
